import PoweredByBadge from "./PoweredByBadge";

## Basic Usage (Static)

<PoweredByBadge badgePosition="static" />

---

## Badge Positions

The badge can be positioned absolutely within a parent container:

export function PositionedBadges() {
  const containerStyle = {
    position: "relative",
    width: "200px",
    height: "150px",
    backgroundColor: "#f1f5f9",
    borderRadius: "8px",
    border: "1px dashed #cbd5e1",
  };
  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
      <div style={containerStyle}>
        <PoweredByBadge badgePosition="topLeft" />
        <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "0.75rem", color: "#64748b" }}>topLeft</span>
      </div>
      <div style={containerStyle}>
        <PoweredByBadge badgePosition="topRight" />
        <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "0.75rem", color: "#64748b" }}>topRight</span>
      </div>
      <div style={containerStyle}>
        <PoweredByBadge badgePosition="bottomLeft" />
        <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "0.75rem", color: "#64748b" }}>bottomLeft</span>
      </div>
      <div style={containerStyle}>
        <PoweredByBadge badgePosition="bottomRight" />
        <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "0.75rem", color: "#64748b" }}>bottomRight</span>
      </div>
    </div>
  );
}

<PositionedBadges />

---

## Custom Offsets

<div style={{ position: "relative", width: "200px", height: "150px", backgroundColor: "#f1f5f9", borderRadius: "8px", border: "1px dashed #cbd5e1" }}>
  <PoweredByBadge badgePosition="bottomRight" offsetX={20} offsetY={20} />
</div>

---

## In Context

<div style={{ position: "relative", width: "300px", height: "200px", backgroundColor: "#1e293b", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
  <span style={{ color: "white", fontSize: "1.25rem" }}>Your Content Here</span>
  <PoweredByBadge badgePosition="bottomRight" />
</div>

